import { FormRowModule } from '../form-row/form-row.module'
import { BusinessSubcategoriesComponent } from './business-subcategories.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { RouterModule } from '@angular/router'
import { TableModule } from '@components/table/table.module'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { PageHeaderModule } from '@components/page-header/page-header.module'

@NgModule({
  declarations: [BusinessSubcategoriesComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormRowModule,
    TranslateModule,
    ContentEditableModule,
    RouterModule,
    TableModule,
    SweetAlert2Module.forRoot(),
    PageHeaderModule,
  ],
  exports: [BusinessSubcategoriesComponent],
})
export class BusinessSubcategoriesModule {}
